/* eslint-disable import/prefer-default-export */
export { default as mockLongRequest } from './mockLongRequest';
